import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, CheckCircle2, Package, Video, FileText, Sparkles, CalendarClock, ArrowRight } from "lucide-react";
import { api, fileUrl } from "@/lib/apiClient";
import { useNavigate } from "react-router-dom";
import { Loader } from "@/components/common";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function Products() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    api.get("/home").then((r) => setEnabled(r.data.niche_courses_enabled));
    api.get("/products").then((r) => setData(r.data)).catch(() => setData({ courses: [], bundle: {} }));
  }, []);
  if (enabled === null || !data) return <Loader />;

  if (!enabled) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="bg-white border border-border rounded-2xl shadow-sm p-8 sm:p-12 text-center" data-testid="niche-coming-soon">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-orange bg-orange/10 px-3 py-1.5 rounded-full"><Sparkles className="w-3.5 h-3.5" /> Coming Soon</span>
          <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-teal/15 to-brandgreen/15 flex items-center justify-center mx-auto my-6">
            <Package className="w-10 h-10 text-teal" />
          </div>
          <h1 className="font-heading text-3xl font-bold">Find Your Niche — Additional Courses</h1>
          <p className="text-muted-foreground mt-3 max-w-lg mx-auto">Deep-dive niche courses (Social Media Management, Bookkeeping, Graphic Design and more) are on the way. For now, the free "How to Get Clients on Upwork" course and 1-on-1 Mentorship are fully available.</p>
          <div className="flex flex-wrap gap-3 justify-center mt-7">
            <Button className="rounded-full bg-teal hover:bg-teal/90" onClick={() => nav("/course")} data-testid="ns-course-btn">Start the Free Course</Button>
            <Button variant="outline" className="rounded-full" onClick={() => nav("/mentorship")} data-testid="ns-mentorship-btn"><CalendarClock className="w-4 h-4 mr-1.5" /> Book Mentorship</Button>
          </div>
        </div>
      </div>
    );
  }

  const Card = ({ p, bundle }) => (
    <Link to={`/products/${p.id}`} className="bg-white border border-border rounded-2xl overflow-hidden shadow-sm hover:-translate-y-1 hover:shadow-md transition-transform block" data-testid={`product-${p.id}`}>
      {!bundle && p.cover_url ? <img src={p.cover_url.startsWith("http") ? p.cover_url : fileUrl(p.cover_url)} alt="" className="w-full h-40 object-cover" />
        : <div className="w-full h-40 bg-gradient-to-tr from-teal/15 to-brandgreen/15 flex items-center justify-center">{bundle ? <Package className="w-12 h-12 text-teal" /> : (p.format === "video" ? <Video className="w-12 h-12 text-teal" /> : <FileText className="w-12 h-12 text-teal" />)}</div>}
      <div className="p-5">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-heading font-semibold">{p.title}</h3>
          {p.unlocked ? <Badge className="bg-brandgreen/10 text-brandgreen"><CheckCircle2 className="w-3 h-3 mr-1" /> Unlocked</Badge> : <Badge variant="secondary"><Lock className="w-3 h-3 mr-1" /> Locked</Badge>}
        </div>
        <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{p.description}</p>
        {!bundle && <p className="text-xs text-teal font-medium mt-2 capitalize">{p.format} course</p>}
      </div>
    </Link>
  );

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold">Additional Niche Courses</h1>
        <p className="text-muted-foreground mt-2">Unlock individual courses or grab the all-in-one bundle.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card p={data.bundle} bundle />
        {data.courses.map((c) => <Card key={c.id} p={c} />)}
      </div>
    </div>
  );
}
